import { render, staticRenderFns } from "./appendix-package.vue?vue&type=template&id=07e49fa5&scoped=true"
import script from "./appendix-package.vue?vue&type=script&lang=js"
export * from "./appendix-package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e49fa5",
  null
  
)

export default component.exports